import { TicketTypeRequestsService } from '../services/TicketTypeRequestsService';

export function useTicketTypeRequestsService(): TicketTypeRequestsService {
  return new TicketTypeRequestsService(useApiClient(), useUserStore());
}
